import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/lib/seo/head";
import AgentLanding from "@/pages/AgentLanding";

export const Route = createFileRoute("/lp/agent")({
  head: () => {
    const head = seoHead("/lp/agent");
    const title = "Agent Partnerships for Buyers & Sellers | Home Approach";
    const description = "A free-to-join growth partnership for real estate agents: support existing clients, explore buyer and seller connections, and add useful Home Approach resources.";
    return {
      ...head,
      meta: [
        ...head.meta.filter((item) => !item.title && !["description", "twitter:title", "twitter:description", "twitter:image"].includes(item.name ?? "") && !["og:title", "og:description", "og:image"].includes(item.property ?? "")),
        { title },
        { name: "description", content: description },
        { property: "og:title", content: title },
        { property: "og:description", content: description },
        { name: "twitter:title", content: title },
        { name: "twitter:description", content: description },
      ],
    };
  },
  component: AgentLanding,
});
